export const PLAY = 'play'
export const PAUSE = 'pause'
export const STOP = 'stop'
export const DIRECTION_FORWARD = 1
export const DIRECTION_REVERSE = -1
